export { default } from './ViewPatientPrescription';
